class SiteElementImages
    extends QueryElement<HTMLElement> {

    private _card: ISiteCard;
    
    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        this._card = card;

        let images = this.query("img").all(a => a);
        for(let image of images)
        {
            image.addClass("image-clickable");
            image.on("click", () => this.enlarge(image.getAttr("src")));
        }
    }

    enlarge(image:string | null)
    {
        if (image == null)
            return;
        
        Site.getSite().showModal(this._card, {
            image: image,
            sort: "Image",
            action: {
                image: image,
                text: "Image",
                title: "Image",
                type: "ShareImage"
            } as IActionTypeShareImage
        } as ISiteImageModal)
    }
}